<template>
  <div id="part-upload">
    <div class="form-header">
      <div @dragover="fileDrag" @drop="fileDrop" class="drag-form" @click="uploadFile">
        <span>将文件拖拽此处, 或<el-button type="text">点击上传</el-button></span>
      </div>
      <input type="file" class="multi-file" name="file" @change="previewFile" ref="inputFile" multiple />
    </div>
    <div></div>
    <div class="file-list">
      <el-alert v-if="msg.length > 0" :title="msg" type="success" :closable="false">
      </el-alert>
      <div v-for="(item, idx) in tempFiles" class="item-list" :key="item.filename">
        <div class="name">
          <span class="t">{{ item.filename }}</span>
          <span class="t2">{{ item.sizeText }}</span>
          <template v-if="item.checked">
            <template v-if="item.uploaded">
              <el-progress type="circle" :percentage="item.percent" :width="50" :status="item.uploaded ? 'success' : 'warning'"></el-progress>
            </template>
            <template v-else>
              <template v-if="item.percent > 0">
                <el-progress type="circle" :percentage="item.percent" :width="50"></el-progress>
              </template>
              <template v-else>
                <span>等待上传</span>
              </template>
            </template>
          </template>
          <template v-else>
            <el-button size="mini" type="danger" :loading="true">计算上传时间...</el-button>
          </template>
          <el-button type="danger" size="mini" plain icon="el-icon-close" @click="deleteItem(idx, item)"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SparkMD5 from "@/util/spark-md5.min.js";
import { MessageBox, Message } from "element-ui";
export default {
  props: {
    maxLength: {
      tpye: Number,
      default: 100000,
    },
    current: String,
  },
  data() {
    return {
      uploadIdxs: [],
      action: process.env.VUE_APP_BASE_API,
      // action: "https://ck.senkoo.cn/prod-api/",
      tempFiles: [],
      files: [],
      msg: "",
      flen: 0,
      startTime: 0,
    };
  },
  created() {},
  methods: {
    deleteItem(idx, item) {
      let inx = this.files.findIndex((x) => x.name == item.name);
      this.tempFiles.splice(idx, 1);
      this.files.splice(inx, 1);
    },
    uploadFile() {
      this.$refs.inputFile.click();
    },
    fileDrag(e) {
      e.preventDefault();
    },
    fileDrop(e) {
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.preloadCheckFile(files);
    },
    getfilesize(size) {
      if (!size) return "";

      var num = 1024.0; //byte

      if (size < num) return size + "B";
      if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + "K"; //kb
      if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
      if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    },
    previewFile(e) {
      var files = e.target.files;
      this.preloadCheckFile(files);
    },
    fileListToArray(flist) {
      return Array.prototype.slice.call(flist);
    },
    preloadCheckFile(files) {
      let fs = this.fileListToArray(files);
      var msg = [];
      fs.forEach((x) => {
        let exist = this.files.filter((m) => m.name == x.name).length;
        if (exist == 0) {
          this.files.push(x);
        } else {
          msg.push(x.name);
        }
      });
      if (msg.length > 0) {
        Message({
          message: `${msg.join(",")}文件已经存在, 无需上传`,
          type: "warning",
        });
      }
      this.flen = this.files.length;
      this.preloadFile();
    },
    preloadFile() {
      let st = new Date().getTime();
      this.startTime = st;
      this.files.forEach((f) => {
        let exist = this.tempFiles.filter((x) => x.filename == f.name).length;
        if (exist > 0) {
          return;
        }
        let h = {
          filename: f.name,
          size: f.size,
          sizeText: this.getfilesize(f.size),
          percent: 0,
          checked: false,
          md5: "",
          uploaded: false,
          filepath: "",
          lastModified: f.lastModified,
          filetype: f.type,
          uploadedChunks: 0,
          chunks: Math.ceil(f.size / 2097152),
        };
        this.tempFiles.push(h);
        this.splitLoading(f, h);
      });
    },
    startUpload(e) {
      this.tempFiles
        .filter((x) => !x.uploaded)
        .forEach((item) => {
          this.files
            .filter((x) => x.name == item.filename)
            .map((t) => {
              this.splitLoading(t, item, "upload");
            });
        });
    },
    splitLoading(file, item, kind) {
      if (item && item.uploaded) {
        return;
      }
      if (!file) {
        return;
      }
      var spark = new SparkMD5.ArrayBuffer();
      var blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      var chunkSize = 2097152;
      var currentChunk = 0;
      var fileReader = new FileReader();
      const self = this;
      if (kind == "upload") {
        fileReader.onload = loadForUploader;
      } else {
        self.uploadedIdxs = [];
        fileReader.onload = loadForMd5;
      }
      fileReader.onerror = function () {
        console.warn("OPPS, 出现了错误");
      };
      function loadForMd5(e) {
        spark.append(e.target.result);
        currentChunk++;
        if (currentChunk < item.chunks) {
          loadNext();
        } else {
          let md5 = spark.end();
          self.fileFindInServe(md5, item);
        }
      }
      function loadForUploader(e) {
        currentChunk++;
        self.fileuploader(
          e.target.result,
          currentChunk,
          item.md5,
          item.filename,
          item.size,
          item.chunks,
          item.lastModified,
          item.filetype
        );
        if (currentChunk < item.chunks) {
          loadNext();
        }
      }
      function loadNext() {
        var start = currentChunk * chunkSize;
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
      }
      loadNext();
    },

    fileuploader(
      fileObj,
      trunkIdx,
      fileMd5,
      filename,
      fileSize,
      chunks,
      lastModified,
      fileType
    ) {
      var s = new SparkMD5.ArrayBuffer();
      s.append(fileObj);
      var pieceMd5 = s.end();
      if (this.uploadIdxs.indexOf(pieceMd5) >= 0) {
        console.log("跳过了=>", pieceMd5);
        return;
      }
      var blob = new Blob([fileObj]);
      var form = new FormData();
      form.append("file", blob);
      form.append("index", trunkIdx);
      form.append("fileMd5", fileMd5);
      form.append("filename", filename);
      form.append("chunks", chunks);
      form.append("fileSize", fileSize);
      form.append("lastModified", lastModified);
      form.append("type", fileType);
      form.append("pieceMd5", pieceMd5);
      form.append("path", this.current);
      var xhr = new XMLHttpRequest();
      xhr.open("post", this.action + "/partUpload", true);
      xhr.onload = this.uploadComplete;
      xhr.onerror = this.uploadFailed;
      xhr.send(form);
    },
    uploadComplete(evt) {
      var fn;
      var md5;
      const self = this;
      var data = JSON.parse(evt.target.responseText);
      if (data.code == 200) {
        if (data.filepath) {
          fn = data.filepath.split("/");
          fn = fn[fn.length - 1];
        }
        if (data.md5) {
          md5 = data.md5;
        }
        self.tempFiles.map((item) => {
          if (item.filename == fn) {
            item.percent = 100;
            self.$refs.inputFile.value = null;
            item.uploaded = true;
            item.filepath = data.filepath;
          }
          if (item.md5 == md5) {
            let percent = Math.ceil((data.data / item.chunks) * 100);
            if (percent >= 100) {
              item.percent = 100;
            } else {
              if (percent >= item.percent) {
                item.percent = percent;
              }
            }
          }
          return item;
        });
        let tmp = self.tempFiles.filter((x) => x.filepath);
        var endtime = new Date().getTime();
        var diff = ((endtime - self.startTime) / 1000).toFixed(2);
        let msg = `共有${self.flen}文件, 成功上传了${tmp.length}个, 耗时: ${diff}秒`;
        self.$emit("uploadFile", data);
        self.msg = msg;
      } else {
        console.log("文件上传失败");
      }
    },
    uploadFailed(evt) {
      console.log("上传失败:", evt);
    },
    cancelUploadFile() {
      console.log("取消");
    },
    fileFindInServe(fileMd5, item) {
      const self = this;
      var form = new FormData();
      var xhr = new XMLHttpRequest();
      xhr.open("get", this.action + "/check?fileMd5=" + fileMd5, true);
      xhr.onload = function (evt) {
        var data = JSON.parse(evt.target.responseText);
        if (data.code == 422) {
          self.tempFiles.map((xd) => {
            if (xd.filename == data.filepath.filename) {
              xd.md5 = fileMd5;
              xd.checked = true;
              xd.uploaded = true;
              xd.percent = 100;
              xd.filepath = data.filepath.filepath;
            }
            return xd;
          });
          let tmp = self.tempFiles.filter((x) => x.filepath);
          var endtime = new Date().getTime();
          var diff = ((endtime - self.startTime) / 1000).toFixed(2);
          let msg = `共有${self.flen}文件, 成功上传了${tmp.length}个, 耗时: ${diff}秒`;
          self.msg = msg;
          self.$emit("uploadFile", tmp);
          return;
        }
        if (data.code == 301) {
          var obj = data.mem;
          Object.keys(obj).forEach(function (k) {
            self.uploadIdxs.push(k);
          });
        }
        self.tempFiles.map((xd) => {
          if (xd.filename == item.filename) {
            xd.md5 = fileMd5;
            xd.checked = true;
          }
          return xd;
        });
        let tmp = self.tempFiles.filter((x) => x.md5.length > 0);
        if (tmp.length == self.flen) {
          self.startUpload();
        }
      };
      xhr.onerror = self.uploadFailed;
      xhr.send(form);
    },
  },
};
</script>

<style lang="scss">
.file-list,
.form-header {
  background: #fff;
  // width: 90%;
  margin: 12px auto;
  border-radius: 20px;
}
.form-header {
  .multi-file {
    display: none;
  }
  .drag-form {
    width: 100%;
    height: 200px;
    border: 1px solid #bdc2c6;
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ccc;
    .el-button--text {
      color: #234b59 !important;
      font-weight: bold;
      font-size: large;
    }
  }
}
.item-list {
  display: flex;
  flex-direction: column;
  padding: 12px 8px;
  border-bottom: 1px solid #dcdfe6;
  .name {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .t {
      min-width: 320px;
    }
    .t2 {
      width: 120px;
    }
  }
}
</style>
